"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.determineInternalDiscountsV2 = exports.determineSitewidePromotionV2 = exports.determineAllPromotionsAndDiscountsV2 = exports.PROMO_SERVICE_IS_ACTIVE = exports.INTERNAL_DISCOUNT_TYPES = exports.PROMO_SERVICE_PROMO_TYPE = exports.determineSwBannerPrefix = void 0;
exports.revalidateInternalDiscount = revalidateInternalDiscount;
exports.revalidateSitewidePromo = revalidateSitewidePromo;
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const pattern_library_utils_cookies_1 = require("@saatva-bits/pattern-library.utils.cookies");
const uniq_1 = __importDefault(require("lodash/uniq"));
const get_1 = __importDefault(require("lodash/get"));
const promotions_services_1 = require("./promotions.services");
const PROMO_SERVICE_PROMO_TYPE = {
    devSale: 'devSale',
    coupon: 'coupon',
    sitewide: 'sitewide'
};
exports.PROMO_SERVICE_PROMO_TYPE = PROMO_SERVICE_PROMO_TYPE;
const INTERNAL_DISCOUNT_TYPES = {
    valueDiscount: 'value_discount',
    includedDiscount: 'included',
    surplusDiscount: 'surplus_discount'
};
exports.INTERNAL_DISCOUNT_TYPES = INTERNAL_DISCOUNT_TYPES;
const SHORT_COOKIE_AGE = 60 * 60 * 2 * 1000; // 2 hours in mils
const THIRTY_DAYS_COOKIE_AGE = 1000 * 60 * 60 * 24 * 30; // 30 days in mils
const PROMO_SERVICE_IS_ACTIVE = 'isActive';
exports.PROMO_SERVICE_IS_ACTIVE = PROMO_SERVICE_IS_ACTIVE;
const determineSwBannerPrefix = (vanityUrls) => {
    return (req, res, next) => {
        const bannerPrefixCookie = pattern_library_utils_cookies_1.Cookies.get('bannerPrefixCode', req);
        const bannerPrefixParam = (0, get_1.default)(req, ['query', 'vanpfx'], '');
        if (bannerPrefixParam) {
            const prefixes = bannerPrefixCookie ? [bannerPrefixParam, ...JSON.parse(bannerPrefixCookie)] : [bannerPrefixParam];
            try {
                const hasValidPrefix = setSWBannerData(res, prefixes, vanityUrls);
                if (hasValidPrefix)
                    return next();
            }
            catch (error) {
                console.error(`[setSWBannerData]: Failed to retrieve and set banner prefix data with message: ${error.message}`);
            }
        }
        if (bannerPrefixCookie) {
            try {
                const parsedPrefixes = JSON.parse(bannerPrefixCookie);
                const hasValidPrefix = setSWBannerData(res, parsedPrefixes, vanityUrls);
                if (hasValidPrefix)
                    return next();
            }
            catch (error) {
                console.error(`[setSWBannerData]: Failed to retrieve and set banner prefix data with message: ${error.message}`);
            }
        }
        if (bannerPrefixCookie) {
            pattern_library_utils_cookies_1.Cookies.remove('bannerPrefixCode', { res });
        }
        return next();
    };
};
exports.determineSwBannerPrefix = determineSwBannerPrefix;
const setSWBannerData = (res, bannerPrefixArray, vanityUrls) => {
    const prefixes = [];
    for (const prefix of bannerPrefixArray) {
        const prefixResult = getPrefixDetails(prefix, vanityUrls);
        if (prefixResult.id && !prefixes.includes(prefix)) {
            prefixes.push(prefix);
        }
    }
    if (prefixes.length > 0) {
        const encodedPrefixes = JSON.stringify(prefixes);
        res.locals.bannerPrefixes = JSON.parse(encodedPrefixes);
        pattern_library_utils_cookies_1.Cookies.set('bannerPrefixCode', encodedPrefixes, { res, maxAge: SHORT_COOKIE_AGE });
        return true;
    }
    return false;
};
const getPrefixDetails = (prefix, vanityUrls) => {
    try {
        const banner = vanityUrls[prefix] ? vanityUrls[prefix].banner : null;
        return banner
            ? {
                id: prefix,
                prefix: banner.prefix,
                isBold: banner.isBold
            }
            : {
                id: null,
                prefix: null,
                isBold: null
            };
    }
    catch (error) {
        return {
            id: null,
            prefix: null,
            isBold: null
        };
    }
};
const getPromoPriorityList = (devSales, coupons, environment = 'production') => {
    const uniqueDevSales = (0, uniq_1.default)(devSales.filter(devSale => !!devSale));
    const uniqueCoupons = (0, uniq_1.default)(coupons.filter(coupon => !!coupon));
    const devSalePriority = uniqueDevSales.map(devSale => ({
        promoConfigType: PROMO_SERVICE_PROMO_TYPE.devSale,
        devSale,
        key: 'discount'
    }));
    const couponPriority = uniqueCoupons.map(coupon => ({
        promoConfigType: PROMO_SERVICE_PROMO_TYPE.coupon,
        coupon,
        key: 'coupon'
    }));
    const sitewidePriority = {
        promoConfigType: PROMO_SERVICE_PROMO_TYPE.sitewide,
        key: 'discount'
    };
    if (environment && environment !== 'production') {
        // if we are not in production we want to use the isActive devSale, if none exist sitewide will be used
        const isActiveDevSale = {
            promoConfigType: PROMO_SERVICE_PROMO_TYPE.devSale,
            devSale: PROMO_SERVICE_IS_ACTIVE,
            key: 'coupon'
        };
        return [
            ...devSalePriority,
            ...couponPriority,
            isActiveDevSale,
            sitewidePriority
        ];
    }
    else {
        return [
            ...devSalePriority,
            ...couponPriority,
            sitewidePriority
        ];
    }
};
const setPromotionCookies = (promotion, response, cookieOptions = {}, couponParam = null) => {
    const { couponCode, isDevSale, devSaleParam } = promotion;
    if (couponParam && couponParam === couponCode) {
        pattern_library_utils_cookies_1.Cookies.set('couponCode', couponCode, { response, ...cookieOptions, maxAge: THIRTY_DAYS_COOKIE_AGE });
    }
    // If a couponCode exists and the couponParam is different, overwrite the couponCode cookie to the param value.
    if (couponParam && couponCode && couponParam !== couponCode) {
        pattern_library_utils_cookies_1.Cookies.set('couponCode', couponParam, { response, ...cookieOptions, maxAge: THIRTY_DAYS_COOKIE_AGE });
    }
    if (isDevSale) {
        pattern_library_utils_cookies_1.Cookies.set('devSale', devSaleParam, { response, maxAge: SHORT_COOKIE_AGE });
    }
};
/**
 * request and response from nextjs: https://nextjs.org/docs/api-reference/next/server
 * @param {object} params
 * @param {(fetcher: () => Promise<any>, promoPriorityList: []) => Promise<any>} params.revalidateSitewidePromo
 * @param {{
 *  url: string;
 *  options?: {
 *      authToken?: string;
 *      captureException?: (error: any) => void;
 *  }
 * }} params.service - Params needed to retrieve internal discount data
 * @returns {Promise<any>}
 */
const determineSitewidePromotionV2 = async (params = {}) => {
    const request = params === null || params === void 0 ? void 0 : params.req;
    const response = params === null || params === void 0 ? void 0 : params.res;
    const environment = params === null || params === void 0 ? void 0 : params.environment;
    const service = params === null || params === void 0 ? void 0 : params.service;
    const cookieOptions = params === null || params === void 0 ? void 0 : params.cookieOptions;
    const couponQuery = request.query.coupon || null;
    const couponParam = Array.isArray(couponQuery) && couponQuery.length > 0 ? couponQuery.pop() : couponQuery;
    const couponCookie = pattern_library_utils_cookies_1.Cookies.get('couponCode', request);
    const devSaleParam = request.query.devSale || null;
    const devSaleCookie = pattern_library_utils_cookies_1.Cookies.get('devSale', request);
    const promoPriorityList = getPromoPriorityList([devSaleParam, devSaleCookie], [couponParam, couponCookie], environment);
    let promotion = {
        enabled: false,
        sitewideName: 'fixed',
        messaging: null
    };
    const getSitewidePromo = async (service, promoPriorityList) => {
        const promoPriorities = promoPriorityList.map(priority => ({
            promoConfigType: priority.promoConfigType,
            coupon: priority.coupon,
            devSale: priority.devSale
        }));
        const serviceOptions = {
            ...service === null || service === void 0 ? void 0 : service.options,
            variables: {
                promoPriorities
            }
        };
        return (0, promotions_services_1.getPromotionServiceData)(service.url, serviceOptions);
    };
    try {
        if (!service) {
            throw Error('Service object is required for determining sitewide promotions');
        }
        if (params === null || params === void 0 ? void 0 : params.revalidateSitewidePromo) {
            const promotionResponse = await (params === null || params === void 0 ? void 0 : params.revalidateSitewidePromo(async () => getSitewidePromo(service, promoPriorityList), promoPriorityList));
            if (promotionResponse)
                promotion = promotionResponse;
        }
        else {
            const promotionResponse = await getSitewidePromo(service, promoPriorityList);
            if (promotionResponse)
                promotion = promotionResponse;
        }
    }
    catch (error) {
        console.error(`[determineSitewidePromotion]: Failed to get promotion details: ${error.message}`);
    }
    setPromotionCookies(promotion, response, cookieOptions, couponParam);
    return promotion;
};
exports.determineSitewidePromotionV2 = determineSitewidePromotionV2;
const transformActiveDiscount = (activeDiscounts) => {
    const transformedData = {};
    for (const property in activeDiscounts) {
        const value = activeDiscounts[property];
        if (typeof value === 'object' && 'key' in value) {
            const { key: discountKey, type, discountAmount, label, siteDiscountedProductSkus: discountedProductSkus, discountConditions: conditions, conditionQuantity, discountValueType, siteConditionSkuSet: conditionSkuSet } = value;
            const discountAmountParsed = JSON.parse(discountAmount || '0');
            const discountValue = typeof discountAmountParsed === 'object'
                ? discountAmountParsed
                : Number(discountAmountParsed);
            if (type === INTERNAL_DISCOUNT_TYPES.valueDiscount) {
                transformedData[property] = {
                    discountKey,
                    discountValue,
                    discountedProductSkus,
                    conditions,
                    conditionQuantity,
                    conditionSkuSet,
                    label
                };
            }
            else if (type === INTERNAL_DISCOUNT_TYPES.includedDiscount) {
                transformedData[property] = {
                    discountKey,
                    discountValue,
                    label
                };
            }
            else if (type === INTERNAL_DISCOUNT_TYPES.surplusDiscount) {
                Object.entries(discountValue).forEach(([sku, discount]) => {
                    if (discount > 0) {
                        transformedData[sku] = {
                            discount,
                            discountValueType,
                            label
                        };
                    }
                });
            }
        }
        else {
            transformedData[property] = value;
        }
    }
    return transformedData;
};
/**
 * @param {object} params
 * @param {((fetcher: () => Promise<any>) => Promise<any>)} [params.revalidateInternalDiscount]
 * @param {{
 *  url: string;
 *  options?: {
 *      authToken?: string;
 *      captureException?: (error: any) => void;
 *  }
 * }} params.service - Params needed to retrieve internal discount data
 * @returns {Promise<{
 *  valueDiscounts: object;
 *  includedDiscounts: object;
 *  surplusDiscounts: object;
 * }>}
 */
const determineInternalDiscountsV2 = async (params = {}) => {
    const service = params === null || params === void 0 ? void 0 : params.service;
    let internalDiscounts = {
        valueDiscounts: {},
        includedDiscounts: {},
        surplusDiscounts: {}
    };
    const fetchInternalDiscounts = async (service) => {
        const result = {
            valueDiscounts: {},
            includedDiscounts: {},
            surplusDiscounts: {}
        };
        const activeDiscount = await (0, promotions_services_1.getActiveDiscountData)(service.url, service.options);
        if (activeDiscount) {
            result.valueDiscounts = transformActiveDiscount(activeDiscount.valueDiscounts);
            result.includedDiscounts = transformActiveDiscount(activeDiscount.includedDiscounts);
            const surplusDiscountsObject = activeDiscount.discounts.reduce((acc, val) => {
                if (val.type === 'surplus_discount' && acc) {
                    return {
                        ...acc,
                        [val.key]: val
                    };
                }
                return acc;
            }, {});
            result.surplusDiscounts = transformActiveDiscount(surplusDiscountsObject);
        }
        return result;
    };
    try {
        if (!service) {
            throw Error('Service object is required for determining internalDiscounts');
        }
        if (params === null || params === void 0 ? void 0 : params.revalidateInternalDiscount) {
            const results = await (params === null || params === void 0 ? void 0 : params.revalidateInternalDiscount(async () => fetchInternalDiscounts(service)));
            internalDiscounts = {
                ...results
            };
        }
        else {
            const results = await fetchInternalDiscounts(service);
            internalDiscounts = {
                ...results
            };
        }
    }
    catch (error) {
        console.error(`[determineInternalDiscounts]: Failed to get discounts details: ${error.message}`);
    }
    return internalDiscounts;
};
exports.determineInternalDiscountsV2 = determineInternalDiscountsV2;
/**
 * Add to the locals the all promotions and discounts data
 *
 * Retrieves necessary data to initialize the internal discouns (surplus) and the sitewide
 * promotions (sitewide, coupon, devsale), the result is saved into the locals object passed through
 * params.
 *
 * if the corresponding revalidateFunction is passed in (either for internal discount or sitewide) data is cached accordingly
 *
 * @export
 * @async
 * @param {{
 *  req: object;
 *  res: object;
 *  next?: () => void;
 *  callback?: () => void;
 *  environment: string;
 *  revalidateSitewidePromo?: (fetcher: () => Promise<any>, promoPriorityList: []) => Promise<any>;
 *  revalidateInternalDiscount?: (fetcher: () => Promise<any>) => Promise<any>;
 *  cookieOptions?: object;
 *  service: {
 *    url: string;
 *    options?: {
 *      authToken?: string;
 *      captureException?: (error: any) => void;
 *    }
 *  }
 * }} params
 * @returns {Promise<() => void | undefined>}
 */
const determineAllPromotionsAndDiscountsV2 = async (params = {}) => {
    const req = params === null || params === void 0 ? void 0 : params.req;
    const res = params === null || params === void 0 ? void 0 : params.res;
    const callback = (params === null || params === void 0 ? void 0 : params.next) || (params === null || params === void 0 ? void 0 : params.callback);
    try {
        const promoServiceData = await determineSitewidePromotionV2(params);
        res.locals.promoServiceData = promoServiceData;
        const internalDiscounts = await determineInternalDiscountsV2(params);
        res.locals.valueDiscounts = internalDiscounts.valueDiscounts;
        res.locals.cartPriceDiscounts = internalDiscounts.includedDiscounts;
        res.locals.surplusSaleDefinitions = internalDiscounts.surplusDiscounts;
        return callback === null || callback === void 0 ? void 0 : callback();
    }
    catch (error) {
        console.error(`[determineAllPromotionsAndDiscounts] Failed to setup promotions with error: ${error.message}`);
        return callback === null || callback === void 0 ? void 0 : callback();
    }
};
exports.determineAllPromotionsAndDiscountsV2 = determineAllPromotionsAndDiscountsV2;
/**
 * Uses closures to be able to pass cacheKey and expiration from the apps outside the promo modules
 *
 * Util function exposed to be imported in apps to override caching behavior and be passed into the determineAllPromotionsAndDiscounts
 *
 * @param {(fetcher: () => any, cacheKey: string, expiration: number) => Promise<any>} getRevalidatingCache
 * @param {string} cacheKey
 * @param {number} expiration
 * @returns {(fetcher: () => any) => Promise<any>}
 */
function revalidateInternalDiscount(getRevalidatingCache, cacheKey, expiration) {
    return async (fetcher) => getRevalidatingCache(fetcher, cacheKey, expiration);
}
/**
 * Uses closures to be able to pass the keyBuilder for the cache keys and the expiration times used internally by the util
 *
 * Util function exposed to be imported in apps to override caching behavior and be passed into the determineAllPromotionsAndDiscounts
 *
 * @param {(fetcher: () => any, cacheKey: string, expiration: number) => Promise<any>} getRevalidatingCache - revaidating cache function from the cache module
 * @param {(...args) => string} keyBuilder - cache key builder from the cache module
 * @param {object} expirationTimes
 * @param {number} expirationTimes.SHORT_CACHE_EXPIRE - expiration used for devsales
 * @param {number} expirationTimes.LONG_CACHE_EXPIRE - expiration used by default
 * @returns {(fetcher: () => any, promoPriorityList: []) => Promise<any>}
 */
function revalidateSitewidePromo(getRevalidatingCache, keyBuilder, expirationTimes) {
    return async (fetcher, promoPriorityList) => {
        for (let i = 0; i < promoPriorityList.length; i++) {
            const promoPriorityObject = promoPriorityList[i];
            const cacheKey = getSitewidePromotionCacheKey(promoPriorityObject, keyBuilder);
            // Only valid keys are taken into account
            if (!cacheKey)
                continue;
            const isDevSale = promoPriorityObject.promoConfigType === 'devSale';
            const promoData = await getRevalidatingCache(fetcher, cacheKey, isDevSale ? expirationTimes.SHORT_CACHE_EXPIRE : expirationTimes.LONG_CACHE_EXPIRE);
            // if the promotion saved in cache or fetched by the revalidation function doesnt match
            // means the promo is most likely invalid, so thats why we need to confirm they match
            const isMatch = isPromoMatch(promoData, promoPriorityObject);
            if (isMatch) {
                console.log(`PROMO IN CACHE (IS MATCH): ${cacheKey}`);
                return promoData;
            }
            else {
                console.log(`PROMO IN CACHE (INVALID): ${cacheKey}`);
            }
        }
    };
}
/**
 * Compare the promotion returned by the promotion service vs the object used to fetch the data
 * if it does not match most likely it means the promo does not exist (maybe an invalid coupon or devsale)
 * @param {object} promo
 * @param {object} promoPriorityObject
 * @returns {boolean}
 */
const isPromoMatch = (promo, promoPriorityObject) => {
    const { promoConfigType, coupon, devSale } = promoPriorityObject;
    const { couponCode, isDevSale, isSitewide, devSaleParam } = promo;
    switch (promoConfigType) {
        case PROMO_SERVICE_PROMO_TYPE.devSale:
            return isDevSale && devSale === devSaleParam;
        case PROMO_SERVICE_PROMO_TYPE.coupon:
            return couponCode === coupon;
        case PROMO_SERVICE_PROMO_TYPE.sitewide:
            return isSitewide && promoConfigType === 'sitewide';
        default:
            return false;
    }
};
/**
 * Depending on the promotion type, returns the corresponding cache key
 *
 * @param {object} promoPriorityObject
 * @param {(...args) => string} keyBuilder - buildKey function from the cache module
 * @returns {string}
 */
const getSitewidePromotionCacheKey = (promoPriorityObject, keyBuilder) => {
    const { promoConfigType, devSale, coupon, key } = promoPriorityObject;
    switch (promoConfigType) {
        case PROMO_SERVICE_PROMO_TYPE.devSale:
            // The cacheKey looks like this ----> discount:devSale-someDevSale or like this ----> coupon:devSale-isActive
            return keyBuilder(key, null, 'devSale', devSale);
        case PROMO_SERVICE_PROMO_TYPE.coupon:
            // The cacheKey looks like this ----> coupon:someCouponCode
            return keyBuilder(key, coupon); // Keep 'coupon' for backwards compat until marketing can be made aware of any changes
        case PROMO_SERVICE_PROMO_TYPE.sitewide:
            // The cacheKey looks like this ----> discount:sitewide
            return keyBuilder(key, 'sitewide');
        default:
            return null;
    }
};
//# sourceMappingURL=promotions.middlewares.js.map